<!-- todo -->
<!-- input validation| formControl -->
<h2 mat-dialog-title>{{'printerclasses.deleteHeadingPrefix' | translate}} {{data.printerClassName}} {{'printerclasses.deleteHeadingSuffix' | translate}}</h2>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>{{'printerclasses.deleteName' | translate}}</mat-label>
    <input matInput [(ngModel)]="data.printerClassName" disabled>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{'printerclasses.deleteDescription' | translate}}</mat-label>
    <input matInput [(ngModel)]="data.printerClassDescription" disabled>
  </mat-form-field>
  @if (data.printerClassMembers) {
    <mat-form-field appearance="outline">
      @if (data.printerClassMembers.length > 0) {
        <mat-label class="existingPrinters">
        {{'printerclasses.deleteExistingPrintersPrefix' | translate}} {{data.printerClassMembers.length}} {{'printerclasses.deleteExistingPrintersSuffix' | translate}}</mat-label>
      }
      <input matInput disabled>
    </mat-form-field>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">{{'printerclasses.deleteAbort' | translate}}</button>
  @if (data.printerClassMembers == null) {
    <div>
      <button mat-raised-button color="warn" [mat-dialog-close]="data" cdkFocusInitial>{{'printerclasses.deleteDelete' | translate}}</button>
    </div>
  }
</mat-dialog-actions>